export const SubAccountCy = {
    ButtonCreate: 'sub-account-create',
    ButtonCancel: 'sub-account-cancel',
    ButtonSubmit: 'sub-account-submit',
}